import React from 'react';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import SelectFieldWrapper from 'modules/blocks/SelectFieldWrapper';
import PasswordWrapper from 'modules/blocks/inputs/PasswordWrapper';
import _ from 'lodash';
import HttpClient from 'services/HttpClient';
import {USER_TYPE, COUNTRIES} from 'constants/baseConst';
import {NURSE_TYPE, MEDICAL_TYPE, POSTCODE_COUNTRIES, IRELAND, DOCTOR_TYPE} from './constants';
import validate from 'validate.js';
import {USER_CONSTRAINS} from 'constants/usersConstrains';
import {inject} from 'mobx-react';
import {Link, withRouter} from 'react-router-dom';
// import Facebook from 'modules/blocks/oauth_buttons/Facebook';
const CREATE_USER = '/api/v1/users';

@withRouter
@inject('userStore')
@inject('alertStore')
export default class SignUpForm extends React.Component {

  state = {
    errors  : {},
    formData: {
      first_name        : '',
      last_name         : '',
      email             : '',
      email_confirmation: '',
      password          : '',
      user_type         : '',
      phone_number      : '',
      imc               : '',
      nmbi              : '',
      country           : '',
      postcode          : ''
    },
    agree: false
  };

  updateCheck = () => {
    this.setState({
      ...this.state,
      agree: !this.state.agree
    })
  }

  submit = e => {
    e.preventDefault();
    if (!this.state.agree) return null;
    let newFormDate = _.assign({}, this.state.formData);
    if (!newFormDate.phone_number) {
      newFormDate.phone_number = null;
    }
    let errors = validate(newFormDate, USER_CONSTRAINS, {fullMessages: false});
    if (errors) {
      this.setState({errors: errors});
    } else {
      this.setState({errors: {}});
      new HttpClient().post(CREATE_USER, {user: this.state.formData}).then(data => {
        const token = data.body.token;
        const user = data.body.user;
        this.props.userStore.loginUser(user, token);
        this.props.alertStore.success('You successfully signed up');
        this.props.history.push('/')
      }).catch(() => {
        this.setState({errors: {email: 'Email has already been taken'}})
      });
    }

  };

  isNurse = () => {
    return NURSE_TYPE.includes(this.state.formData.user_type);
  };

  isMedical = () => {
    return MEDICAL_TYPE.includes(this.state.formData.user_type);
  };

  isIrelandDoctor = () => {
    return DOCTOR_TYPE.includes(this.state.formData.user_type) && IRELAND.includes(this.state.formData.country);
  };

  isPostcodeCountry = () => {
    return POSTCODE_COUNTRIES.includes(this.state.formData.country);
  };

  handleChange = e => {
    if (e.target.name === 'user_type') {
      this.changeAdditionalForms(e);
    } else {
      let newState = _.assign({}, this.state.formData, {[e.target.name]: e.target.value});
      this.setState({formData: newState});
    }
  };

  changeAdditionalForms = e => {
    if (NURSE_TYPE.includes(e.target.value) || !MEDICAL_TYPE.includes(e.target.value)) {
      let newState = _.assign({}, this.state.formData,
        {nmbi: '', imc: '', [e.target.name]: e.target.value});
      let errors = _.assign([], this.state.errors);
      errors.imc = null;
      errors.nmbi = null;
      this.setState({formData: newState, errors: errors});
    }
    else {
      let newState = _.assign({}, this.state.formData, {[e.target.name]: e.target.value});
      this.setState({formData: newState});
    }
  };

  render() {
    return (
      <div className="form-wrapper sign-up-wrapper">
        <div className="form-container">
          {/* <div className="form-header-wrap">
            <div className="auth-switcher">
              <Facebook/>
              <div className="or">
                <span>or</span>
              </div>
              <div className="label">Sign Up with your email address</div>
            </div>
          </div> */}
          <div className="form-content col-4">
            <form className="sign-up-form" onSubmit={this.submit}>
              <div className="name-info-block">
                <div className="row justify-content-between">
                  <div className="col-6">
                    <div className="input-wrap">
                      <TextField
                        onChange={this.handleChange}
                        className='name'
                        name="first_name"
                        value={this.state.formData.first_name}
                        floatingLabelText="First Name"
                        type="text"
                        errorText={this.state.errors.first_name}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="input-wrap">
                      <TextField
                        className='surname'
                        name="last_name"
                        value={this.state.formData.last_name}
                        errorText={this.state.errors.last_name}
                        onChange={this.handleChange}
                        floatingLabelText="Surname"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="input-wrap select-wrap">
                <SelectFieldWrapper
                  elements={USER_TYPE}
                  placeholder="I am a:"
                  name='user_type'
                  value={this.state.formData.user_type}
                  onChange={this.handleChange}
                  errorText={this.state.errors.user_type}
                  style={{position: 'absolute'}}
                  className="select"
                />
              </div>
              <div className="input-wrap select-wrap">
                <SelectFieldWrapper
                  elements={COUNTRIES}
                  placeholder="Country"
                  name='country'
                  value={this.state.formData.country}
                  onChange={this.handleChange}
                  errorText={this.state.errors.country}
                  style={{position: 'absolute'}}
                  className="select"
                />
              </div>
              {this.isPostcodeCountry() &&
                <div className="input-wrap">
                  <TextField
                    name="postcode"
                    value={this.state.formData.postcode}
                    onChange={this.handleChange}
                    className='name'
                    errorText={this.state.errors.postcode}
                    floatingLabelText="Postcode/Zipcode"
                    type="text"
                  />
                </div>
              }
              <div className="input-wrap">
                <TextField
                  name="email"
                  value={this.state.formData.email}
                  onChange={this.handleChange}
                  className='email'
                  errorText={this.state.errors.email}
                  floatingLabelText="Email"
                  type="email"
                />
              </div>
              <div className="input-wrap">
                <TextField
                  name="email_confirmation"
                  onChange={this.handleChange}
                  value={this.state.formData.email_confirmation}
                  className='confirm-email'
                  errorText={this.state.errors.email_confirmation}
                  floatingLabelText="Confirm email"
                  type="email"
                />
              </div>
              <PasswordWrapper value={this.state.formData.password}
                errorText={this.state.errors.password}
                name="password"
                placeholder="Password"
                handleChange={this.handleChange}
              />
              { !this.state.errors.password &&
                <span className="input-label">Must be at least 6 characters and contain at least one number and one capital letter</span>
              }
              {/*<div className="input-wrap">*/}
              {/*<TextField*/}
              {/*className='password'*/}
              {/*name="password"*/}
              {/*value={this.state.formData.password}*/}
              {/*onChange={this.handleChange}*/}
              {/*hintText="Password"*/}
              {/*errorText={this.state.errors.password}*/}
              {/*floatingLabelText="Password"*/}
              {/*type="password"*/}
              {/*/>*/}
              {/*{ !this.state.errors.password &&*/}
              {/*<span className="input-label">Must be at least 6 characters and contain at least one number and one capital letter</span>*/}
              {/*}*/}
              {/*</div>*/}
              {/*<div className="input-wrap">
                <TextField
                  onChange={this.handleChange}
                  value={this.state.formData.phone_number}
                  className='phone'
                  errorText={this.state.errors.phone_number}
                  name="phone_number"
                  floatingLabelText="Phone"
                  type="text"
                />
              </div>*/}
              {/* {this.isNurse() && <div className="input-wrap"
                                        key="nmbi">
                <TextField
                  onChange={this.handleChange}
                  value={this.state.formData.nmbi}
                  className='name'
                  errorText={this.state.errors.nmbi}
                  name="nmbi"
                  floatingLabelText="NMBI Number"
                  type="text"
                />
              </div>} */}
              {this.isIrelandDoctor() &&
                <div className="input-wrap" key="imc">
                  <TextField
                    onChange={this.handleChange}
                    value={this.state.formData.imc}
                    className='name'
                    errorText={this.state.errors.imc}
                    name="imc"
                    floatingLabelText="IMC Number"
                    type="text"
                  />
                </div>
              }
              <div className='agree-wrap'>
                 <Checkbox
                  label=''
                  checked={this.state.agree}
                  onCheck={this.updateCheck}
                />
                <span>I agree to the <a href="/terms-of-service">Terms of Service</a> and <a href="/privacy-policy">Privacy Policy</a></span>
              </div>
              <div className="button-set">
                <button className="btn blue rounded submit-btn" type="submit" disabled={!this.state.agree}>Sign Up</button>
                <div className="help-label">
                  <span>Already have an account? </span><Link className="log-in" to="/signIn">Log In</Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/containers/SignUpForm.js